export default __webpack_public_path__ + "static/media/history-3.70ca222c.png";